/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleLetterN = createReactComponent("circle-letter-n", "IconCircleLetterN", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 16v-8l4 8v-8", key: "svg-1" }]
]);

export { IconCircleLetterN as default };
//# sourceMappingURL=IconCircleLetterN.js.map
